import { ArrowRight, Plus } from "lucide-react";
import { SOLUTIONS } from "../../data/content";
import { ChapterHeading } from "./ChapterHeading";
import { Reveal } from "./Reveal";
import { discussService } from "../../lib/scroll";

export const Solutions = () => (
    <section
        id="solutions"
        data-testid="solutions-section"
        className="py-24 lg:py-32 bg-[#0A0E17]/60 border-y border-white/5"
    >
        <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
            <ChapterHeading
                label="Business Solutions"
                title="What Can We Build For Your Business?"
                sub="Solution examples shaped around real business types — each one a practical combination of website, enquiry, booking and automation systems."
            />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
                {SOLUTIONS.map((s, i) => (
                    <Reveal key={s.name} delay={(i % 3) * 0.08}>
                        <div
                            data-testid={`solution-card-${i}`}
                            className="group h-full rounded-2xl border border-white/8 bg-[#0D131F] p-6 flex flex-col transition-all duration-300 hover:border-[#F5C518]/40 hover:-translate-y-1"
                        >
                            <div className="flex items-center gap-4 mb-5">
                                <div className="h-11 w-11 rounded-xl bg-[#F5C518]/10 border border-[#F5C518]/25 flex items-center justify-center shrink-0 transition-transform duration-300 group-hover:scale-110">
                                    <s.icon size={20} className="text-[#F5C518]" />
                                </div>
                                <h3 className="font-display text-lg font-semibold text-white">
                                    {s.name}
                                </h3>
                            </div>
                            <ul className="flex-1 space-y-2 mb-6">
                                {s.includes.map((inc) => (
                                    <li
                                        key={inc}
                                        className="flex items-center gap-2 text-sm text-slate-400"
                                    >
                                        <Plus size={13} className="text-[#00E5FF] shrink-0" />
                                        {inc}
                                    </li>
                                ))}
                            </ul>
                            <button
                                data-testid={`solution-build-${i}`}
                                onClick={() => discussService(`${s.name} Solution`)}
                                className="inline-flex items-center gap-2 self-start rounded-full border border-[#F5C518]/40 px-5 py-2.5 text-sm font-medium text-[#F5C518] transition-all duration-300 hover:bg-[#F5C518] hover:text-[#07090E] active:scale-95"
                            >
                                Build This Solution <ArrowRight size={14} />
                            </button>
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal className="mt-8">
                <p className="text-xs text-slate-500 font-jbmono tracking-wide">
                    * These are solution examples, not completed client projects.
                </p>
            </Reveal>
        </div>
    </section>
);
